@import 'styles/mixins';
@import 'styles/blaze/mixins';

.loadingPreviewContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .loadingPreviewHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px;

    [data-autopilot-system-redesign='on'] & {
      padding: 14px 20px 14px 14px;
    }

    .headerLeft {
      display: flex;
      align-items: center;
      gap: 10px;

      [data-autopilot-system-redesign='on'] & {
        gap: 5px;
      }
    }

    .headerCenter {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;

      :global .ant-skeleton {
        width: 168px !important;

        [data-autopilot-system-redesign='on'] & {
          width: 320px !important;
        }

        .ant-skeleton-content {
          width: 168px !important;

          [data-autopilot-system-redesign='on'] & {
            width: 320px !important;
          }

          .ant-skeleton-title {
            border-radius: 8px;
            height: 40px;

            [data-autopilot-system-redesign='on'] & {
              height: 24px;
            }
          }
        }
      }
    }

    .headerRight {
      display: flex;
      align-items: center;
      gap: 13px;

      :global .ant-skeleton {
        width: 24px !important;
      }
    }

    :global .ant-skeleton-with-avatar {
      width: 24px !important;

      .ant-skeleton-header {
        padding: 0 !important;

        span {
          background: var(--dark-8) !important;
        }
      }
    }

    :global .ant-skeleton .ant-skeleton-active {
      .ant-skeleton-content {
        width: 115px !important;
      }
    }

    :global .ant-skeleton {
      width: 115px !important;

      .ant-skeleton-content {
        width: 115px !important;

        .ant-skeleton-title {
          margin-top: 0 !important;
          height: 24px;
          border-radius: 90px;
          background: var(--dark-8);
        }
      }
    }
  }

  .loadingPreviewContent {
    width: 100%;
    height: calc(100% - 58px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > div {
      aspect-ratio: var(--aspect-ratio);
    }
  }
}
